module.exports = __webpack_public_path__ + "img/truck_04.58b97aa5.jpg";